var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", [_c("h1", [_vm._v(_vm._s(_vm.name))])]),
      _vm._v(" "),
      _vm.isLuzmoReportsEnabled
        ? _c("luzmo-embed-dashboard", {
            ref: "dashboardInstance",
            attrs: {
              dashboardId: _vm.$route.params.id,
              switchScreenModeOnResize: true,
              authKey: _vm.token.key,
              authToken: _vm.token.token
            }
          })
        : _c("cumulio-dashboard", {
            ref: "dashboardInstance",
            attrs: {
              dashboardId: _vm.$route.params.id,
              switchScreenModeOnResize: true,
              authKey: _vm.token.key,
              authToken: _vm.token.token
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }